














































import Vue from 'vue';

import { AddLink } from './types';

export default Vue.extend({
  data() {
    return {
      link: '',
      title: '',
    };
  },
  computed: {
    canSubmit(): boolean {
      return this.link !== '' && this.title !== '';
    },
  },
  methods: {
    onSubmit(event: Event) {
      event.preventDefault();

      if (!this.canSubmit) {
        return;
      }

      const data: AddLink = {
        link: this.link,
        title: this.title,
      };

      this.$emit('input', data);

      this.link = '';
      this.title = '';

      (this.$refs.linkInput as HTMLInputElement).focus();
    },
    updateLink(event: Event) {
      if (event.currentTarget.value.length > 2083) {
        window.GGRC.Notify({
          type: 'warning',
          message: 'The URL was too long and was truncated to 2083 characters',
        });
      }
      const url = event.currentTarget.value.slice(0, 2083);
      this.link = url;
    },
  },
});
